// Full-width row above the transactions table that lets the user start a new
// transaction. Clicking the trigger opens the shared NewTransactionDropdown.

import React from "react";
import NewTransactionDropdown from "./NewTransactionDropdown";

// onAdd is kept as an optional (deprecated) prop so existing callers do not break.
interface AddChequeRowProps {
  onAdd?: (d: { type: string; amount: number; payee: string }) => void;
}

const TRIGGER_CLASS =
  "inline-flex items-center gap-1.5 text-teal-dark text-[13px] font-semibold " +
  "bg-transparent border-none cursor-pointer hover:underline px-0";

export default function AddChequeRow(_props: AddChequeRowProps) {
  return (
    <div className="border-b border-lineSoft bg-[#F9FAFB]">
      <div className="px-4 md:px-8 py-2.5">
        <NewTransactionDropdown
          triggerLabel="+ Add cheque"
          triggerClassName={TRIGGER_CLASS}
        />
      </div>
    </div>
  );
}